export default "__VITE_ASSET__CDLx29uj__"